class ProductInterest extends HTMLElement {
  static CACHE_DURATION = 2 * 60 * 60 * 1000;

  connectedCallback() {
    const productId = this.dataset.productId;
    const template = this.dataset.template;

    if (!productId || !template) {
      this.hidden = true;
      return;
    }

    const count = this.#getCount(productId);
    this.textContent = template.replace('__COUNT__', count);
  }

  #getCount(productId) {
    const cacheKey = `product-interest-${productId}`;
    const cached = this.#readCache(cacheKey);

    if (cached && Date.now() - cached.createdAt < ProductInterest.CACHE_DURATION) {
      return cached.count;
    }

    const count = Math.floor(Math.random() * 20) + 1;

    try {
      localStorage.setItem(cacheKey, JSON.stringify({ count, createdAt: Date.now() }));
    } catch (error) {
      // The label still works when storage is blocked; only persistence is lost.
    }

    return count;
  }

  #readCache(cacheKey) {
    try {
      return JSON.parse(localStorage.getItem(cacheKey));
    } catch (error) {
      return null;
    }
  }
}

if (!customElements.get('product-interest')) {
  customElements.define('product-interest', ProductInterest);
}
